import { AgencyConstants } from 'features/Agency/agencyHelper';
import _ from 'lodash';
import { useMemo } from 'react';
import { useSelector } from 'react-redux';

useAppConfig.propTypes = {};

function useAppConfig(props) {
  const config = useSelector((state) => state.app.appConfig?.config);
  // link dieu khoan
  const termsUrl =
    _.find(config, (item) => item.key === 'termsUrl')?.value ??
    'https://evglobal.vn/dieu-khoan-va-chinh-sach/';

  // ty le hoa hong ban nhuong quyen
  const commissionRateSale =
    _.find(config, (item) => item.key === AgencyConstants.ConfigKey.COMMISSION_RATE_SALE)?.value ??
    0;
  // ty le hoa hong ban goi dau tu HTKD
  const commissionRateGroup =
    _.find(config, (item) => item.key === AgencyConstants.ConfigKey.COMMISSION_RATE_GROUP)?.value ??
    0;
  // hoa hong gioi thieu mat bang
  const commissionRateLandlord = _.find(
    config,
    (item) => item.key === AgencyConstants.ConfigKey.COMMISSION_RATE_LANDLORD
  )?.value;
  // ty le hoa hong ban tru sac
  const commissionRateChargePoint =
    _.find(config, (item) => item.key === AgencyConstants.ConfigKey.COMMISSION_RATE_CHARGEPOINT)?.value ??
    0;

  // agencyId mac dinh
  const groupAgencyId = Number(_.find(config, (item) => item.key === 'groupAgencyId')?.value);

  // chu ky so cua admin
  const adminAgreementUUID = _.find(config, (item) => item.key === 'adminAgreementUUID')?.value;
  const adminPasscode = _.find(config, (item) => item.key === 'adminPasscode')?.value;

  // chi phi mat bang mac dinh
  const defaultLandlordMonthlyRent = Number(_.find(config, (item) => item.key === 'defaultLandlordMonthlyRent')?.value);
  const defaultLandlordSlotRent = Number(_.find(config, (item) => item.key === 'defaultLandlordSlotRent')?.value);
  const showShareRatio = Number(_.find(config, (item) => item.key === 'showShareRatio')?.value);

  // cac rang buoc khi KTV checkin
  const checkinMaxDistance = Number(_.find(config, (item) => item.key === 'checkinMaxDistance')?.value);
  const checkinTimeBefore = Number(_.find(config, (item) => item.key === 'checkinTimeBefore')?.value);
  const checkinTimeAfter = Number(_.find(config, (item) => item.key === 'checkinTimeAfter')?.value);

  return useMemo(() => {
    return {
      termsUrl,

      commissionRateSale,
      commissionRateGroup,
      commissionRateLandlord,
      commissionRateChargePoint,

      groupAgencyId,
      defaultLandlordMonthlyRent,
      defaultLandlordSlotRent,
      showShareRatio,

      adminAgreementUUID,
      adminPasscode,

      checkinMaxDistance,
      checkinTimeBefore,
      checkinTimeAfter,
    };
  }, [config]);
}

export default useAppConfig;
